import {createAction, props} from "@ngrx/store";
import {BuildingQueue} from "../../models/BuildingQueue";

export const UPDATE = '[BuildingQueue] Update';
export const REFRESH = '[BuildingQueue] Refresh';
export const update = createAction(UPDATE, props<{ buildingQueue: BuildingQueue[] }>());
export const refresh = createAction(REFRESH);
